import styled from "@emotion/styled";
import { Container, Typography, Grid } from "@mui/material";
import React from "react";
import AboutImg from "../../../assets/About.png";

const AboutContainer = styled(Container)`
    background-color: #000024;
    padding-top:10px;
    padding-bottom: 50px;
    @media (max-width: 749px){
        padding-top: 20px;
        padding-bottom: 40px;
    }
    @media (min-width: 1900px){
        padding-top: 50px;
        padding-bottom: 50px;
    }

`
const ContentGrid = styled(Grid)`
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family: poppins-b;
    text-align: center;
    @media (max-width: 749px){
        font-size:30px;
    }
`
const P = styled.p`
    color: #fff;
    font-size: 15px;
    font-family: poppins-light;
    text-align: center;
    width:85%;
    @media (max-width: 1100px){
        width:100%;
    }
    @media (max-width: 600px){
        font-size: 13px;
    }
`
const ReadMoreBtn = styled.a`
    color:#000;
    background-color: #fff;
    border-radius: 9px;
    font-size: 14px;
    padding:11px 35px;
    border-color:#FFFFFF;
    margin-top:30px;
    @media (max-width: 600px){
        font-size: 16px;
        padding:6px 20px;
        margin-top:15px;
    }
`
const Aboutimg = styled.img`
    width:100%;
    max-width:100%;
    height:auto;
    margin:50px 30px 30px 30px;
    @media (max-width: 600px){
        margin:20px 30px 20px 30px;
    }
`
const About = () => {
    return(
            <AboutContainer maxWidth="xxl" id="about">
                <Container maxWidth="xl" sx={{padding:'0px'}}>
                    <Grid container>
                        <ContentGrid item xs={12} sm={12}>
                            <Heading data-aos="zoom-in" variant="h1">About The Project</Heading>
                            <Aboutimg data-aos="zoom-in" src={AboutImg} alt="" />
                            <P data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">Welcome to Pulse Mixer, the leading privacy-focused mixer on the Pulse network.
                                 We are dedicated to revolutionizing the way you protect your financial transactions
                                  by offering advanced privacy solutions. With our state-of-the-art zero-knowledge 
                                  protocols and innovative mixing algorithm, we ensure that your transactions remain 
                                  completely confidential and anonymous. Say goodbye to prying eyes and unwanted surveillance as
                                 you explore the possibilities of secure and private transactions with Pulse Mixer.
                            </P>
                            <P data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">At Pulse Mixer, we prioritize your ease of use and seamless integration. Our user-friendly
                                 interface enables you to effortlessly mix your funds and protect your privacy without any 
                                 technical barriers. We seamlessly integrate with the Pulse network, allowing you to leverage 
                                 our privacy-enhancing features while enjoying the benefits of a decentralized and vibrant ecosystem.
                                  Rest assured that your transactions are shielded by robust encryption and stringent security measures,
                                   safeguarding your funds from unauthorized access. 
                                Join us today and experience the future of confidential transactions with Pulse Mixer.
                            </P>
                            <ReadMoreBtn data-aos="zoom-in">Read More</ReadMoreBtn>
                        </ContentGrid>
                    </Grid>
                </Container>
            </AboutContainer>
    );
}

export default About;